import { AddIcon } from '@systemeio/ui/icons'
import { Modal, PrimaryButton, RadioGroup, RadioGroupDataInterface, SecondaryButton, Tooltip } from '@systemeio/ui'
import {
  EventTypeEnum,
  eventChooseTypeLocoKeys,
} from 'modules/calendar/events/enums/event-type-enum'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface EventCreateModalProps {
  limitReached?: boolean
  isFetchingEventLimit: boolean
}

export const EventCreateModal = ({ isFetchingEventLimit, limitReached }: EventCreateModalProps) => {
  const { t } = useLocoTranslation()
  const router = useRouter()

  const [opened, setOpened] = useState<boolean>(false)
  const [eventType, setEventType] = useState<EventTypeEnum>(EventTypeEnum.Individual)

  const eventTypeData: RadioGroupDataInterface<EventTypeEnum>[] = [
    {
      id: EventTypeEnum.Individual,
      caption: t(eventChooseTypeLocoKeys[EventTypeEnum.Individual]),
    },
    {
      id: EventTypeEnum.Group,
      caption: t(eventChooseTypeLocoKeys[EventTypeEnum.Group]),
    },
  ]

  return (
    <>
      <Tooltip
        disabled={!limitReached}
        mode={'hover'}
        label={t('dashboard.calendar.event_limit_tooltip')}
      >
        <PrimaryButton
          onClick={() => setOpened(true)}
          isFetching={isFetchingEventLimit}
          disabled={limitReached}
        >
          <AddIcon />
          <span className="hidden sm:flex">{t('dashboard.calendar.create_new_event')}</span>
        </PrimaryButton>
      </Tooltip>
      <Modal
        title={t('dashboard.calendar.choose_event_type')}
        opened={opened}
        onClose={() => setOpened(false)}
      >
        <RadioGroup
          optionsWrapperClassName={'flex-col items-start'}
          selected={eventType}
          options={eventTypeData}
          onChange={value => setEventType(value)}
        />
        <div className="mt-4 flex justify-end gap-4">
          <SecondaryButton width="large" onClick={() => setOpened(false)}>
            {t('confirmation_modal.cancel')}
          </SecondaryButton>
          <PrimaryButton
            width="large"
            onClick={() => {
              router.push(`/calendar/create?eventType=${eventType}`)
            }}
          >
            {t('confirmation_modal.confirm')}
          </PrimaryButton>
        </div>
      </Modal>
    </>
  )
}
